import { useParams } from 'react-router-dom';

export function useReferralId() {
  const { referralId } = useParams<{ referralId?: string }>();

  return referralId;
}
